import {
  type DynamicClient,
  type WalletAccount,
} from '@dynamic-labs-sdk/client';
import {
  consumeMfaTokenIfRequiredForAction,
  getSignedSessionId,
} from '@dynamic-labs-sdk/client/core';
import type { WaasProvider } from '@dynamic-labs-sdk/client/waas/core';
import { MFAAction } from '@dynamic-labs/sdk-api-core';
import type { TypedData } from 'viem';
import { stringify } from 'viem';

type SignTypedDataParams = {
  typedData: TypedData | { [key: string]: unknown };
  waasProvider: WaasProvider;
  walletAccount: WalletAccount;
};

/** @not-instrumented */
// eslint-disable-next-line custom-rules/require-single-object-param
export const signTypedData = async (
  { typedData, walletAccount, waasProvider }: SignTypedDataParams,
  dynamicClient: DynamicClient
) => {
  const { signature: signedSessionId } = await getSignedSessionId(
    dynamicClient
  );

  const mfaToken = await consumeMfaTokenIfRequiredForAction(
    { mfaAction: MFAAction.WalletWaasSign },
    dynamicClient
  );

  const waasClient = await waasProvider.getWaasClient();

  // serialize bigint values
  const stringifiedTypedData = stringify(typedData);
  const serializableTypedData = JSON.parse(stringifiedTypedData) as string;

  return waasClient.signTypedData({
    accountAddress: walletAccount.address,
    authToken: dynamicClient.token ?? undefined,
    mfaToken,
    signedSessionId,
    typedData: serializableTypedData,
  });
};
